import React, {useState} from 'react';
import ShowMoreText_ from 'react-show-more-text';
import styles from './ShowMoreText.module.scss';

interface IHotelReview {
  showLabel?: string;
  hideLabel?: string;
  className?: string;
  lines: number;

  children: string;

  truncatedEndingComponent?: any;
}


const ShowMoreText = (props: IHotelReview) => {
  const [showMoreText, setShowMoreText] = useState(false);
  return (<ShowMoreText_
      /* Default options */
      lines={props.lines}
      more={props.showLabel}
      less={props.hideLabel}
      className={`${styles.content} ${props.className}`.trim()}
      anchorClass={styles.anchor}
      onClick={setShowMoreText}
      expanded={showMoreText}
      truncatedEndingComponent={props.truncatedEndingComponent}

    >
      {props.children}
    </ShowMoreText_>
  )
};

ShowMoreText.defaultProps = {
  children: '',
  showLabel: 'הצג עוד',
  hideLabel: 'הסתר',
  className: '',
  lines: 2,
};

export default React.memo(ShowMoreText);
